import ReactDOM from 'react-dom/client';
import './lib/translations/i18n';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { getEnv } from '@/lib/utils/common/getEnv';
import { App } from './app';
import './styles.css';
import { datadogRum } from '@datadog/browser-rum';
import { FeatureFlagOverrideProvider } from '@/lib/providers/featureFlagOverrideContext';
import { setupAnalytics, trackPageView } from './lib/analytics/analytics';
import { initializeDatadogRUM } from './lib/monitoring/datadog-rum';
import { router } from './router';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const AppWithLDProvider = withLDProvider({
  clientSideID: getEnv().launchDarklyClientSideId,
  timeout: 5,
  options: {
    logger: {
      debug: () => undefined,
      info: () => undefined,
      warn: () => undefined,
      // biome-ignore lint/suspicious/noConsole: we want this logged
      error: console.error,
    },
    application: {
      id: 'spm-frontend',
      version: '0.1.0',
    },
  },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
})(App);

initializeDatadogRUM();
setupAnalytics();

let lastRouterPath: string | null = null;

router.subscribe('onLoad', () => {
  const matches = router.state.matches;
  const lastMatch = matches?.[matches.length - 1];
  const routePath = lastMatch?.fullPath || '/';
  if (lastRouterPath !== routePath) {
    trackPageView(routePath);

    // Track view in Datadog RUM
    datadogRum.startView({ name: routePath });

    lastRouterPath = routePath;
  }
});

root.render(
  <FeatureFlagOverrideProvider>
    <AppWithLDProvider />
  </FeatureFlagOverrideProvider>,
);
